import React, { Component } from 'react';

import template from 'url-template';

import { connect } from 'react-redux';

import { get, isEmpty } from 'lodash';

import CircularProgress from '@material-ui/core/CircularProgress';

import ConfirmButton from '../../components/ConfirmButton';
import NoDataSadFace from '../../components/NoDataSadFace';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import NiagaraDevicesTable from './NiagaraDevicesTable';
import BacnetDevicesTable from './BacnetDevicesTable';
import CreateBacnetDeviceModal from '../Modals/CreateBacnetDeviceModal';
import CreateNiagaraDeviceModal from '../Modals/CreateNiagaraDeviceModal';
import DeleteDeviceModal from '../Modals/DeleteDeviceModal';
import ImportCSVModal from '../Modals/ImportCSVModal';
import UpdateDeviceProfileModal from '../Modals/UpdateDeviceProfileModal';
import ManageBacnetDeviceModal from '../Modals/ManageBacnetDeviceModal';
import ManageNiagaraDeviceModal from '../Modals/ManageNiagaraDeviceModal';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './DevicesObjectsPanel.module.css';

import * as BasAgentActions from '../../actions/basAgentActions';
import * as DeviceActions from '../../actions/deviceActions';
import * as CoreActions from '../../actions/coreActions';

const InventoryUrl = template.parse('/iothub/basagents/manage/inventory/{basType}{?company,basAgent}');
const ManageNetworkUrl = template.parse('/iothub/basagents/manage/network{?company,basAgent}');

class DevicesObjectsPanel extends Component {
    state = {
        basType:                      '',
        createBacnetDeviceModalOpen:  false,
        createNiagaraDeviceModalOpen: false,
        deleteDeviceModalOpen:        false,
        devicesToDelete:              [],
        importCSVModalOpen:           false,
        manageBacnetDeviceModalOpen:  false,
        manageNiagaraDeviceModalOpen: false,
        searchFilter:                 '',
        selectState:                  {},
        updateDeviceProfileModalOpen: false,
        workbookModeEnabled:          false
    }

    componentDidMount() {
        const { selectedAgent } = this.props;

        const basType = get(selectedAgent, 'driverConfiguration[0].basType', '').toLowerCase();

        switch (basType) {
            case 'bacnetip':
            case 'bacnetethernet':
                this.setState({ basType: 'bacnet' });
                break;
            default:
                this.setState({ basType });
                break;
        }
    }

    handleViewBasInventory = () => {
        const { history, selectedAgent, companyInfo } = this.props;
        const { basType } = this.state;

        if (!selectedAgent.driverConfiguration.length) {
            return;
        }

        const companyId = get(companyInfo, 'companyId', '');
        const basAgentId = get(selectedAgent, 'id', '');

        history.push(InventoryUrl.expand({
            basType,
            company:  companyId,
            basAgent: basAgentId
        }));
    }

    handleConfigureBasNetwork = () => {
        const { history, companyInfo, selectedAgent } = this.props;

        const companyId = get(companyInfo, 'companyId', '');
        const basAgentId = get(selectedAgent, 'id', '');
        history.push(ManageNetworkUrl.expand({
            company:  companyId,
            basAgent: basAgentId
        }));
    }

    handleChangeProfile = () => {
        this.setState({
            updateDeviceProfileModalOpen: true
        });
    }

    handleCloseUpdateDeviceProfileModal = () => {
        this.props.devicesToggle([]);
        this.setState({
            updateDeviceProfileModalOpen: false
        });
    }

    handleCreateDevice = () => {
        const { basType } = this.state;

        if (basType === 'bacnet') {
            this.setState({
                createBacnetDeviceModalOpen: true
            });
        } else if (basType === 'niagara') {
            this.setState({
                createNiagaraDeviceModalOpen: true
            });
        }
    }

    handleDelete = device => {
        const { id, name } = device.dataItem;

        this.setState({
            deleteDeviceModalOpen: true,
            devicesToDelete:       [{id, name}]
        });
    }

    handleDeleteSelected = () => {
        this.setState({
            deleteDeviceModalOpen: true
        });
    }

    handleCloseCreateBacnetDeviceModal = () => {
        this.setState({
            createBacnetDeviceModalOpen: false
        });
    }

    handleCloseCreateNiagaraDeviceModal = () => {
        this.setState({
            createNiagaraDeviceModalOpen: false
        });
    }

    handleCloseDeleteDeviceModal = () => {
        this.setState({
            deleteDeviceModalOpen: false,
            devicesToDelete:       []
        });
    }

    handleImportCSV = props => {
        this.props.setDevice(props.dataItem);
        this.setState({
            importCSVModalOpen: true
        });
    }

    handleCloseImportCSVModal = () => {
        this.setState({
            importCSVModalOpen: false
        });
    }

    handleManageNiagaraDevice = props => {
        this.props.setDevice(props.dataItem);
        this.setState({
            manageNiagaraDeviceModalOpen: true
        });
    }

    handleManageBacnetDevice = props => {
        this.props.setDevice(props.dataItem);
        this.setState({
            manageBacnetDeviceModalOpen: true
        });
    }

    handleCloseManageBacnetDeviceModal = () => {
        this.setState({
            manageBacnetDeviceModalOpen: false
        });
    }

    handleCloseManageNiagaraDeviceModal = () => {
        this.setState({
            manageNiagaraDeviceModalOpen: false
        });
    }

    toggleWorkbookMode = () => {
        this.setState({
            workbookModeEnabled: !this.state.workbookModeEnabled
        });
    }

    updateSelectedState = devices => {
        this.setState({
            selectState: devices
        });
    }

    resetSelectState = () => {
        this.setState({
            selectState: {}
        });
    }

    stripFileTypeHeader = (file) => {
        if (file) {
            let fileArray = file.split(';base64,');
            fileArray.shift();
            return fileArray.join('');
        }

        return null;
    }

    convertProfiles = (profiles) => {
        const { selectedAgent } = this.props;
        const basType = get(selectedAgent, 'driverConfiguration[0].basType', '');

        const selectedProfiles = profiles.filter(profile => profile.basType === basType);

        const data = [
            {
                items: [
                    ...selectedProfiles
                ],
                name:      'Profiles',
                itemProps: {
                    type: 'profiles'
                }
            }
        ];
        return data;
    };

    renderButton = () => {
        const { basType } = this.state;
        const { selectedAgent } = this.props;

        if (isEmpty(basType) ||
            isEmpty(selectedAgent.serialNumber) ||
            basType.toLowerCase() === 'notconfigured') {
            return (
                <ConfirmButton
                    confirm={this.handleConfigureBasNetwork}
                    label="Configure BAS Network"
                    className={classes.noDataButton}
                />
            );
        }
        return (
            <ConfirmButton
                confirm={this.handleViewBasInventory}
                label="View BAS Inventory"
                className={classes.noDataButton}
            />
        );
    }

    renderTable = () => {
        const {
            companyInfo,
            currentScopes,
            devices,
            devicesToggle,
            reloadDeviceObjects,
            selectedAgent,
            setDevice,
        } = this.props;

        const { basType } = this.state;

        const isFullHubAllowed = isAllowed(currentScopes, Permissions('iothubFull'));

        if (basType === 'bacnet') {
            return (
                <BacnetDevicesTable
                    agentId={selectedAgent.id}
                    devices={devices}
                    companyInfo={companyInfo}
                    isFullHubAllowed={isFullHubAllowed}
                    onDeviceToggle={devicesToggle}
                    onDeleteModal={this.handleDelete}
                    onImportModal={this.handleImportCSV}
                    onManageModal={this.handleManageBacnetDevice}
                    scopes={currentScopes}
                    setDevice={setDevice}
                    reloadDeviceObjects={reloadDeviceObjects}
                    workbookModeEnabled={this.state.workbookModeEnabled}
                    updateSelectedState={this.updateSelectedState}
                />
            );
        } else if (basType === 'niagara') {
            return (
                <NiagaraDevicesTable
                    agentId={selectedAgent.id}
                    devices={devices}
                    companyInfo={companyInfo}
                    isFullHubAllowed={isFullHubAllowed}
                    onDeviceToggle={devicesToggle}
                    onDeleteModal={this.handleDelete}
                    onImportModal={this.handleImportCSV}
                    onManageModal={this.handleManageNiagaraDevice}
                    scopes={currentScopes}
                    setDevice={setDevice}
                    reloadDeviceObjects={reloadDeviceObjects}
                    workbookModeEnabled={this.state.workbookModeEnabled}
                    updateSelectedState={this.updateSelectedState}
                />
            );
        }
    }

    renderContent = () => {
        const { devices, devicesLoading } = this.props;
        const { searchFilter } = this.state;
        const showTable = !!devices.length;

        if (devicesLoading) {
            return (
                <div className={classes.devicesObjectsContainer}>
                    <div className={classes.loading}>
                        <CircularProgress
                            size={50}
                        />
                    </div>
                </div>
            );
        }

        return (
            <React.Fragment>
                {
                    !showTable && !searchFilter &&
                        <div className={classes.noDataContainer}>
                            <div className={classes.noData}>
                                <NoDataSadFace />
                                {this.renderButton()}
                            </div>
                        </div>
                }
                {
                    !showTable && searchFilter &&
                        <div className={classes.devicesObjectsContainer}>
                            <p className={classes.noResultsFound}>
                                No Results Found
                            </p>
                        </div>
                }
                {
                    showTable &&
                        <div className={classes.devicesObjectsContainer}>
                            {this.renderTable()}
                        </div>
                }
            </React.Fragment>
        );
    };

    render() {
        const {
            devices,
            currentScopes,
            selectedDevice,
            profiles,
            selectedAgent,
        } = this.props;

        const isFullHubAllowed = isAllowed(currentScopes, Permissions('iothubFull'));

        let devicesToDelete = this.state.devicesToDelete;
        if (!devicesToDelete.length) {
            Object.keys(this.state.selectState).forEach(key => {
                if (this.state.selectState[key] === false) {
                    delete this.state.selectState[key];
                }
            });

            devicesToDelete = Object.keys(this.state.selectState).map(key => ({ id: key }));
            devicesToDelete.forEach(item => {
                const found = devices.find(device => device.id === item.id);

                if (found) {
                    item.name = found.name;
                    item.basProfileId = found.basProfileId;
                    item.configurationId = found.configurationId;
                    item.deviceId = found.deviceId;
                    item.macAddress = found.macAddress;
                    item.model = found.model;
                    item.vendor = found.vendor;
                    item.oBIXPath = found.oBIXPath;
                    item.type = found.type;
                }
            });
        }

        return (
            <React.Fragment>
                <ActionBar>
                    <ActionBarItem
                        onClick={this.toggleWorkbookMode}
                        type="edit"
                    >
                        Workbook Mode
                    </ActionBarItem>
                    <ActionBarItem
                        disabled={this.state.basType === 'notconfigured'}
                        onClick={this.handleCreateDevice}
                        hidden={!isFullHubAllowed}
                        type="add"
                    >
                        Create Device
                    </ActionBarItem>
                    <ActionBarItem
                        disabled={!Object.values(this.state.selectState).find(item => item === true)}
                        onClick={this.handleChangeProfile}
                        hidden={!isFullHubAllowed}
                        type="profile"
                    >
                        Change Device Profile
                    </ActionBarItem>
                    <ActionBarItem
                        disabled={!Object.values(this.state.selectState).find(item => item === true)}
                        onClick={this.handleDeleteSelected}
                        hidden={!isFullHubAllowed}
                        type="delete"
                    >
                        Delete Device
                    </ActionBarItem>
                </ActionBar>
                {this.renderContent()}
                <CreateBacnetDeviceModal
                    open={this.state.createBacnetDeviceModalOpen}
                    close={this.handleCloseCreateBacnetDeviceModal}
                    profiles={this.convertProfiles(profiles)}
                    agent={selectedAgent}
                />
                <CreateNiagaraDeviceModal
                    open={this.state.createNiagaraDeviceModalOpen}
                    close={this.handleCloseCreateNiagaraDeviceModal}
                    profiles={this.convertProfiles(profiles)}
                    agent={selectedAgent}
                />
                <DeleteDeviceModal
                    open={this.state.deleteDeviceModalOpen}
                    resetSelectState={this.resetSelectState}
                    close={this.handleCloseDeleteDeviceModal}
                    devices={devicesToDelete}
                />
                <ImportCSVModal
                    open={this.state.importCSVModalOpen}
                    close={this.handleCloseImportCSVModal}
                    stripFileTypeHeader={this.stripFileTypeHeader}
                />
                <UpdateDeviceProfileModal
                    open={this.state.updateDeviceProfileModalOpen}
                    resetSelectState={this.resetSelectState}
                    close={this.handleCloseUpdateDeviceProfileModal}
                    devices={devicesToDelete}
                />
                <ManageNiagaraDeviceModal
                    open={this.state.manageNiagaraDeviceModalOpen}
                    close={this.handleCloseManageNiagaraDeviceModal}
                    device={selectedDevice}
                    profiles={profiles}
                    agent={selectedAgent}
                    title="Manage Niagara Device"
                />
                <ManageBacnetDeviceModal
                    open={this.state.manageBacnetDeviceModalOpen}
                    close={this.handleCloseManageBacnetDeviceModal}
                    device={selectedDevice}
                    profiles={profiles}
                    agent={selectedAgent}
                    title="Manage Bacnet Device"
                />
            </React.Fragment>
        );
    }
}

export const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    const { devices, updatedAt, selectedDevices } = state.device;

    return {
        companyInfo:        state.companyInfo,
        currentScopes:      state.core.currentScopes,
        devices,
        devicesLoading:     state.device.devicesLoading,
        profiles:           state.profile.profiles,
        selectedAgent,
        updatedAt,
        selectedDevices,
        selectedDevice:     state.device.selectedDevice,
        progressBarLoading: state.core.progressBarLoading,
    };
};

const mapDispatchToProps = {
    ...BasAgentActions,
    ...DeviceActions,
    ...CoreActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DevicesObjectsPanel);
